import { alertActions } from 'srcReact/Alert'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components'
import { eventService, generalService, groupService } from 'srcReact/services'
import { mixrConstants as mc } from './constants'

export const mixrActions = {
  setAttendingType,
  getMixrDetails,
  getMedias,
  resetAfterPostFeed,
  getParticipants,
  deleteFileFromMixr,
  addStaffRole,
  removeStaffRole,
  cancelMixr,
  joinGroup,
  setMixrRole,
  setPreviewMixrData,
  createMixr,
  editMixr,
  getRecurrenceEndDate,
  getFeeCategories,
  clearCreatedMixrValues,
  setInviteInfo,
  resetEditSuccessFlag,
  clearRecuEndDateError,
  setMixrData,
  setInitialState,
  saveDraft,
  getDrafts,
  getDraftDetail,
  deleteDraft,
  getExistingMixrList,
  setPreviewFromModalFlag,
  resetSaveDraftData,
  resetSaveDraftError,
  getUsersToInvite,
  updateAttendanceFromRSVP,
  showAdvanceSetting,
  sendInvites,
  updateMixrRating,
  getMoreReviews
}

function setMixrRole(joinedGroup) {
  return { type: mc.SET_MIXR_ROLE, joinedGroup }
}

function resetSaveDraftData() {
  return { type: mc.RESET_SAVE_DRAFT }
}

function resetSaveDraftError() {
  return { type: mc.RESET_SAVE_DRAFT_ERROR }
}
function setPreviewFromModalFlag(isSet) {
  return { type: mc.SET_PREVIEW_FROM_MODAL_FLAG, isSet }
}

function setAttendingType(attending) {
  return { type: mc.SET_ATTENDING_TYPE, attending }
}

function setPreviewMixrData(mixrData, user, previewInModal, attachedGroupId) {
  return { type: mc.SET_PREVIEW_MIXR_DATA, mixrData, user, previewInModal, attachedGroupId }
}
function updateAttendanceFromRSVP(rsvpData) {
  return { type: mc.UPDATE_RSVP_DATA, rsvpData }
}

function resetEditSuccessFlag() {
  return {
    type: mc.RESET_EDIT_SUCCESS_FLAG
  }
}

function setInviteInfo(inviteInfo) {
  return {
    type: mc.SET_INVITE_INFO,
    inviteInfo
  }
}
function clearRecuEndDateError() {
  return {
    type: mc.CLEAR_RECUR_END_DATE_ERROR
  }
}

function clearCreatedMixrValues() {
  return {
    type: mc.CLEAR_CREATED_MIXR_VALUES
  }
}

function getMixrDetails(id, scope, isPreview, loggedInUser, previewInModal, attachedGroup) {
  return (dispatch) => {
    dispatch(request(id))

    eventService.getEventDetailById(id, scope).then(
      (response) => {
        if (isPreview) {
          //attachedGroup is the group object coming from group page plan mixr cta/selected group from basic info section of create mixr
          let updatedMixr = response.mixr
          if (attachedGroup) {
            updatedMixr = {
              ...response.mixr,
              group: attachedGroup
            }
          }
          dispatch(setPreviewMixrData(updatedMixr, loggedInUser, previewInModal))
        } else {
          dispatch(success(response))
        }
      },
      (error) => {
        dispatch(failure(error))
        // dispatch(alertActions.error(error?.message || error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_MIXR_DETAIL_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_MIXR_DETAIL_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_MIXR_DETAIL_FAILURE, error }
  }
}

function getParticipants(
  id,
  scope,
  attendingType,
  pagination,
  search,
  order,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))

    eventService.getParticipants(id, scope, attendingType, nextOffset, quantity, search, order).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(isPagination) {
    return { type: mc.GET_USERS_REQUEST, isPagination }
  }
  function success(response) {
    const updatedResponse = { ...response, isPagination, search, scope }
    return { type: mc.GET_USERS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: mc.GET_USERS_FAILURE, error }
  }
}

function getMedias(id) {
  return (dispatch) => {
    dispatch(request(id))

    eventService.getEventDetailById(id, '').then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_MEDIA_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_MEDIA_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_MEDIA_FAILURE, error }
  }
}

function resetAfterPostFeed() {
  return { type: mc.RESET_AFTER_MESSAGE_POSTED }
}

function deleteFileFromMixr(mixrId, fileId) {
  return (dispatch) => {
    dispatch(request({ mixrId, fileId }))

    eventService.deleteFileFromMixr(mixrId, fileId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.DELETE_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.DELETE_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.DELETE_FILE_FAILURE, error }
  }
}

function addStaffRole(mixrId, userId, role) {
  return (dispatch) => {
    dispatch(request({ mixrId, userId, role }))

    eventService.addStaffRole(mixrId, userId, role).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.ADD_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.ADD_STAFF_ROLE_SUCCESS, response, actionType: 'add' }
  }
  function failure(error) {
    return { type: mc.ADD_STAFF_ROLE_FAILURE, error }
  }
}

function removeStaffRole(mixrId, userId, scope) {
  return (dispatch) => {
    dispatch(request({ mixrId, userId }))

    eventService.removeStaffRole(mixrId, userId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.REMOVE_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.REMOVE_STAFF_ROLE_SUCCESS, response, scope, actionType: 'remove' }
  }
  function failure(error) {
    return { type: mc.REMOVE_STAFF_ROLE_FAILURE, error }
  }
}
function cancelMixr(mixrId, recurrenceCancel) {
  return (dispatch) => {
    dispatch(request({ mixrId }))

    eventService.cancelMixr(mixrId, recurrenceCancel).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.CANCEL_MIXR_REQUEST, response }
  }
  function success(response) {
    return { type: mc.CANCEL_MIXR_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.CANCEL_MIXR_FAILURE, error }
  }
}

function joinGroup(groupId, invitedBy = '') {
  return (dispatch) => {
    dispatch(request(groupId))

    groupService.joinGroup(groupId, invitedBy).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.JOIN_GROUP_REQUEST, response }
  }
  function success(response) {
    return { type: mc.JOIN_GROUP_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.JOIN_GROUP_FAILURE, error }
  }
}

function createMixr(groupId, mixr) {
  return (dispatch) => {
    dispatch(request({ groupId, mixr }))

    eventService.createEvent(groupId, mixr).then(
      (response) => {
        // To set createdMixrId and createdMixrUrl for a newly created event in local storage, especially for a native app
        const { mixr } = response
        localStorage.setItem('created_mixr_id', JSON.stringify(mixr.id))
        localStorage.setItem('created_mixr_url', JSON.stringify(mixr.url))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.CREATE_MIXR_REQUEST, response }
  }
  function success(response) {
    return { type: mc.CREATE_MIXR_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.CREATE_MIXR_FAILURE, error }
  }
}

function editMixr(mixrId, mixr, recurrenceUpdate = 'unique', hasInviteData = false) {
  return (dispatch) => {
    dispatch(request(mixrId))
    if (!hasInviteData) {
      delete mixr.is_invite_scheduled
      delete mixr.invite_send_date
    }
    eventService.editEvent(mixrId, mixr, recurrenceUpdate).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.EDIT_MIXR_REQUEST, response }
  }
  function success(response) {
    return { type: mc.EDIT_MIXR_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.EDIT_MIXR_FAILURE, error }
  }
}

function getRecurrenceEndDate(
  startAt,
  endAt,
  recurrenceType,
  recurrenceEndDate = null,
  recurrenceWeeksCount = -1,
  recurrenceDaysOfWeek = '',
  recurrenceMonthsCount = -1,
  recurrenceDayOfWeek = -1,
  recurrenceOccurenceInMonth = -1
) {
  return (dispatch) => {
    dispatch(request())

    eventService
      .getRecurrenceEndDate(
        startAt,
        endAt,
        recurrenceType,
        recurrenceEndDate,
        recurrenceWeeksCount,
        recurrenceDaysOfWeek,
        recurrenceMonthsCount,
        recurrenceDayOfWeek,
        recurrenceOccurenceInMonth
      )
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: mc.GET_RECUR_END_DATE_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_RECUR_END_DATE_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_RECUR_END_DATE_FAILURE, error }
  }
}
function getFeeCategories(langauage = '') {
  return (dispatch) => {
    dispatch(request(langauage))

    eventService.getFeeCategories(langauage).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_FEE_CATEGORIES_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_FEE_CATEGORIES_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_FEE_CATEGORIES_FAILURE, error }
  }
}

function setMixrData(arrKeyValue) {
  return {
    type: mc.SET_MIXR_DATA_BY_KEY,
    arrKeyValue
  }
}

function setInitialState() {
  return {
    type: mc.SET_INITIAL_STATE
  }
}

function saveDraft(event) {
  return (dispatch) => {
    dispatch(request({ event }))

    eventService.saveDraft(event).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }
  function request(response) {
    return { type: mc.SAVE_DRAFT_REQUEST, response }
  }
  function success(response) {
    return { type: mc.SAVE_DRAFT_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.SAVE_DRAFT_FAILURE, error }
  }
}

function getDrafts(
  organizationId,
  groupId,
  searchGroupId,
  search,
  pagination,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organizationId, groupId, searchGroupId, search, pagination }))

    eventService.getDrafts(organizationId, groupId, searchGroupId, search, pagination.nextOffset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_DRAFTS_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_DRAFTS_SUCCESS, response, search, pagination }
  }
  function failure(error) {
    return { type: mc.GET_DRAFTS_FAILURE, error }
  }
}

function getDraftDetail(draftId, isPreview, loggedInUser, previewInModal, attachedGroup) {
  return (dispatch) => {
    dispatch(request({ draftId }))

    eventService.getDraftDetail(draftId).then(
      (response) => {
        if (isPreview) {
          const {
            start_at,
            end_at,
            recurrence,
            recurrence: { type, end_date, weeks_count, days_of_week, months_count, day_of_week, occurence_in_month }
          } = response.draft_event
          //attachedGroup is the group object coming from group page plan mixr cta/selected group from basic info section of create mixr
          let updatedDraftMixr = response.draft_event
          if (attachedGroup) {
            updatedDraftMixr = {
              ...response.draft_event,
              group: attachedGroup
            }
          }
          if (type === 'none') {
            dispatch(setPreviewMixrData(updatedDraftMixr, loggedInUser, previewInModal))
          } else {
            eventService
              .getRecurrenceEndDate(
                start_at,
                end_at,
                type,
                end_date,
                weeks_count,
                days_of_week,
                months_count,
                day_of_week,
                occurence_in_month
              )
              .then((responseRecurrenceEvents) => {
                const responseWithEvents = {
                  ...updatedDraftMixr,
                  recurrence: {
                    ...recurrence,
                    events: responseRecurrenceEvents.events.filter((e) => e.will_be_created === 1)
                  }
                }
                dispatch(setPreviewMixrData(responseWithEvents, loggedInUser, previewInModal))
              }),
              (error) => {
                dispatch(failure(error))
              }
          }
        } else {
          dispatch(success(response))
        }
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_DRAFT_DATA_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_DRAFT_DATA_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_DRAFT_DATA_FAILURE, error }
  }
}

function getExistingMixrList(
  organizationId,
  groupId,
  searchGroupId,
  search,
  pagination,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organizationId, groupId, searchGroupId, search, pagination }))

    eventService
      .getExistingMixrList(organizationId, groupId, searchGroupId, search, pagination.nextOffset, quantity)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: mc.GET_EXISTING_MIXRS_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_EXISTING_MIXRS_SUCCESS, response, search, pagination }
  }
  function failure(error) {
    return { type: mc.GET_EXISTING_MIXRS_FAILURE, error }
  }
}

function deleteDraft(draftId) {
  return (dispatch) => {
    dispatch(request({ draftId }))

    eventService.deleteDraft(draftId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.DELETE_DRAFT_REQUEST, response }
  }
  function success(response) {
    return { type: mc.DELETE_DRAFT_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.DELETE_DRAFT_FAILURE, error }
  }
}

function getUsersToInvite(mixrId, search, order, pagination, quantity = appConstantSettings.PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ mixrId }))

    eventService.getUsersToInvite(mixrId, 'suggested_members', pagination.nextOffset, quantity, search, order).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_USERS_TO_INVITE_REQUEST, response, pagination }
  }
  function success(response) {
    return { type: mc.GET_USERS_TO_INVITE_SUCCESS, response, pagination, search }
  }
  function failure(error) {
    return { type: mc.GET_USERS_TO_INVITE_FAILURE, error }
  }
}

function showAdvanceSetting() {
  return { type: mc.SHOW_ADVANCE_SETTING }
}

function sendInvites(event_id, usersId, message, callbackSuccess) {
  return (dispatch) => {
    dispatch(request({ event_id, usersId, message }))

    eventService.sendInvites(event_id, usersId, message).then(
      (response) => {
        dispatch(success(response))
        if (typeof callbackSuccess === 'function') {
          const isSomeUsersFailed = response?.users?.some((x) => x.status === 'not_allowed')
          if (isSomeUsersFailed) {
            dispatch(failure('error'))
          } else {
            callbackSuccess()
          }
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.SEND_INVITES_REQUEST, response }
  }
  function success(response) {
    return { type: mc.SEND_INVITES_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.SEND_INVITES_FAILURE, error }
  }
}

function updateMixrRating(organizationId, mixrId, isPublic, rating, review, fromMixrPage) {
  return (dispatch) => {
    dispatch(request({ organizationId, mixrId, isPublic, rating }))

    eventService.updateMixrRating(organizationId, mixrId, isPublic, rating, review).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.UPDATE_MIXR_RATING_REQUEST, response }
  }
  function success(response) {
    return { type: mc.UPDATE_MIXR_RATING_SUCCESS, response, fromMixrPage }
  }
  function failure(error) {
    return { type: mc.UPDATE_MIXR_RATING_FAILURE, error }
  }
}

function getMoreReviews(mixrId, offset, quantity = 3) {
  return (dispatch) => {
    dispatch(request({ mixrId, offset, quantity }))

    eventService.getMoreReviews(mixrId, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: mc.GET_MORE_REVIEWS_REQUEST, response }
  }
  function success(response) {
    return { type: mc.GET_MORE_REVIEWS_SUCCESS, response }
  }
  function failure(error) {
    return { type: mc.GET_MORE_REVIEWS_FAILURE, error }
  }
}
